import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom }: Theme) => ({
  scaleWrapper: {
    height: '100%',
    position: 'relative',
  },
  document: {
    height: 1128,
    width: 798,
    position: 'relative',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    transformOrigin: 'center center',
    boxShadow: custom.shadow[1],
  },
  sidebarPreviewModal: {
    maxWidth: 'unset',
    padding: 0,
    overflow: 'visible',
    backgroundColor: 'transparent',
    boxShadow: 'none',
    height: '90vh',
  },
  closeBtn: {
    position: 'absolute',
    top: 10,
    right: 10,
  },
  headerCloseButton: {
    color: custom.grey[1],
    cursor: 'pointer',
  },
}));
